import { status } from '@theme/colors/status';

export const muiStepIcon = {
  styleOverrides: {
    root: {
      '&.Mui-completed': {
        color: status.success,
      },
    },
  },
};
